export default __webpack_public_path__ + "static/media/turn-ideas-into-reality.93b003a2.jpg";